import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postAuthenticated } from './api';

export interface UpdateCustomerRequest {
  customerSub: string;
  processStatus: string;
}

export const useMutateCustomerStatus = () => {
  const url = `admin/update-customer/process-status`;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['customers'],
    mutationFn: async (request: UpdateCustomerRequest) => {
      const body = JSON.stringify(request);
      return postAuthenticated<UpdateCustomerRequest>(url, body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
  });
};
